<template>
  <div class="w-full flex items-center">
    <div class="bg-white rounded-full w-full h-full overflow-x-hidden">
      <div
        class="h-full rounded-full relative"
        :class="`bg-${color}`"
        :style="style"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: Number,
    max: Number,
    color: String,
  },

  computed: {
    style() {
      return {
        width: (this.value / this.max) * 100 + "%",
      };
    },
  },
};
</script>
